<template>
  <b-modal
    v-model="show"
    hide-header
    hide-footer
    centered
    @hide="hideModal"
  >
    <form
      id="editModal"
      @submit.prevent="editRole"
    >
      <div class="modal-header align-items-center">
        <h2
          id="ModalLabel"
          class="modal-title"
        >
          Редактирование роли
        </h2>
        <i class="material-icons">edit</i>
      </div>
      <div class="modal-body">
        Роль:
        <span id="login_place">
          {{ roleEdited.name }}
        </span>
        <hr />
        <div class="form-group">
          <label
            for="groups"
            class="col-form-label"
          >
            Доступность:
          </label>
          <multiselect
            v-model="availableFor"
            :options="roleListFiltered"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder="Выберите роль"
            selected-label="Роль добавлена"
            select-label="Добавить роль"
            deselect-label="Убрать роль"
          >
            <template slot="noResult">
              По данному запросу ничего не найдено
            </template>
            <template slot="noOptions">
              Нет доступных ролей
            </template>
          </multiselect>
        </div>
        <div class="form-group">
          <label
            for="groups"
            class="col-form-label"
          >
            Совместимость:
          </label>
          <multiselect
            v-model="compatibleWith"
            :options="roleListFiltered"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder="Выберите роль"
            selected-label="Роль добавлена"
            select-label="Добавить роль"
            deselect-label="Убрать роль"
          >
            <template slot="noResult">
              По данному запросу ничего не найдено
            </template>
            <template slot="noOptions">
              Нет доступных ролей
            </template>
          </multiselect>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary-ford-gray modal-ext"
          type="button"
          @click="hideModal"
        >
          Отмена
        </button>
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="submit"
        >
          Изменить
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import clone from 'lodash.clonedeep';

export default {
  name: 'EditRole',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    roleEdited: {
      type: Object,
      required: true,
    },
    roleList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    show: false,
    availableFor: [],
    compatibleWith: [],
    fields: [
      {
        key: 'subject',
        label: 'Тема',
      },
      {
        key: 'to',
        label: 'Кому',
      },
      {
        key: 'cc',
        label: 'В копии',
      },
      {
        key: 'from',
        label: 'От',
      },
    ],
  }),
  computed: {
    roleListFiltered() {
      return this.roleList.map(it => it.name);
    },
  },
  watch: {
    value(val) {
      this.show = val;
      this.availableFor = clone(this.roleEdited).availableFor;
      this.compatibleWith = clone(this.roleEdited).compatibleWith;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
    async editRole() {
      const requestOptions = {
        availableFor: this.availableFor,
        compatibleWith: this.compatibleWith,
      };

      await this.$http.post(`users/1.0/roles/${this.roleEdited.id}`, requestOptions);
      this.$emit('editRole');
    },
  },
};
</script>
